import React from 'react';
import Link from 'gatsby-link';
import { slugify } from '../components/slugify';
import BackgroundImage from 'react-background-image-loader';
import Helmet from 'react-helmet';
import Img from 'gatsby-image';
import Slider from 'react-slick';
import ScrollToTop from 'react-scroll-up';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

// import Img from 'gatsby-image'
var BaseHref = 'http://46.4.51.11:1337'


const BueroPage = ({ data }) => (

<div>
    <Helmet
        bodyAttributes={{
            class: 'buero'
        }}
    />
        <ScrollToTop 
            showUnder={160}
            style={
                {
                    position: 'fixed',
                    bottom: 80,
                    right: 0,
                    cursor: 'pointer',
                    transitionDuration: '0.2s',
                    transitionTimingFunction: 'linear',
                    transitionDelay: '0s',
                    zIndex: '999'
                }
            }
            >
            <button className="slick-arrow slick-up"></button>
        </ScrollToTop>

    <div className="row buero-row">
            <div className="col-md-12 IsotopeFilter">
                <AnchorLink href='#geschaeftsleitung'>Gesch&auml;ftsleitung</AnchorLink>
                <AnchorLink href='#unternehmen'>Unternehmen</AnchorLink>
                <AnchorLink href='#qualifikationen'>Qualifikationen</AnchorLink>
                <AnchorLink href='#qm'>Qualit&auml;ts&shy;management</AnchorLink>
            </div>
    </div>

    <div className="about">

        <h1 id="geschaeftsleitung" style={{paddingTop: "3em", marginBottom: "0"}}>Die Gesch&auml;ftsleitung</h1>
        <div className="row" style={{ marginTop: '0' }}>
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 team_img">

                <Img
                    sizes={data.team.sizes}
                />

            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 accordion-container">
                <small style={{ color: "#60809e", padding: "15px", display: "block"}}>v.l.n.r</small>
                <Accordion>

                    <AccordionItem key={"gf3" + data.strapiAbout.id}>
                        <AccordionItemTitle>
                            <div className="title">
                                {data.strapiAbout.gf_3_name}
                            </div>
                            <div className="more" />
                        </AccordionItemTitle>
                        <AccordionItemBody>
                            <div className="row">
                                <div className="col-md-4">
                                    <Img
                                        sizes={data.TH.sizes}
                                        style={{
                                            position: "relative",
                                            left: 0,
                                            top: 0,
                                            width: "100%",
                                            height: "100%"
                                        }}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <div dangerouslySetInnerHTML={{ __html: data.strapiAbout.gf_3_text }} />
                                </div>
                            </div>
                        </AccordionItemBody>
                    </AccordionItem>

                    <AccordionItem key={"gf1" + data.strapiAbout.id}>
                        <AccordionItemTitle>
                            <div className="title">
                                {data.strapiAbout.gf_1_name}
                            </div>
                            <div className="more" />
                        </AccordionItemTitle>
                        <AccordionItemBody>
                            <div className="row">
                                <div className="col-md-4">
                                    <Img
                                        sizes={data.CB.sizes}
                                        style={{
                                            position: "relative",
                                            left: 0,
                                            top: 0,
                                            width: "100%",
                                            height: "100%"
                                        }}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <div dangerouslySetInnerHTML={{ __html: data.strapiAbout.gf_1_text }} />
                                </div>
                            </div>
                        </AccordionItemBody>
                    </AccordionItem>

                    <AccordionItem key={"gf2" + data.strapiAbout.id}>
                        <AccordionItemTitle>
                            <div className="title">
                                {data.strapiAbout.gf_2_name}
                            </div>
                            <div className="more" />
                        </AccordionItemTitle>
                        <AccordionItemBody>
                            <div className="row">
                                <div className="col-md-4">
                                    <Img
                                        sizes={data.CM.sizes}
                                        style={{
                                            position: "relative",
                                            left: 0,
                                            top: 0,
                                            width: "100%",
                                            height: "100%"
                                        }}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <div dangerouslySetInnerHTML={{ __html: data.strapiAbout.gf_2_text }} />
                                </div>
                            </div>
                        </AccordionItemBody>
                    </AccordionItem>

                    <AccordionItem key={"gf4" + data.strapiAbout.id}>
                        <AccordionItemTitle>
                            <div className="title">
                                {data.strapiAbout.gf_4_name}
                            </div>
                            <div className="more" />
                        </AccordionItemTitle>
                        <AccordionItemBody>
                            <div className="row">
                                <div className="col-md-4">
                                    <Img
                                        sizes={data.LW.sizes}
                                        style={{
                                            position: "relative",
                                            left: 0,
                                            top: 0,
                                            width: "100%",
                                            height: "100%"
                                        }}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <div dangerouslySetInnerHTML={{ __html: data.strapiAbout.gf_4_text }} />
                                </div>
                            </div>
                        </AccordionItemBody>
                    </AccordionItem>
                        <quote>
                            <span className="orange">«</span><span>&nbsp;Wir sind Ihr Team &ndash; wenn Kompetenz, Erfahrung und Leistung gefragt sind.</span>&nbsp;<span className="orange">»</span>
                        </quote>
                </Accordion>

            </div>
        </div>

        <div className="row" style={{ marginTop: '4em' }}>
            <div className="col-sm-6 col-md-4 nopadd" style={{ paddingLeft: 0, paddingRight: 0, backgroundColor: '#ffffff' }}>
                <div className="col-md-12 " style={{ backgroundColor: 'rgba(112, 146, 169, 1)' }}>
                    <h2 id="unternehmen" style={{ color: '#ffffff' }}>Wir verbinden Wissen und K&ouml;nnen</h2>
                </div>
                <div style={{ padding: '2em' }} dangerouslySetInnerHTML={{ __html: data.strapiAbout.Text_Allg }} />
            </div>
            <div className="col-sm-6 col-md-8  nopadd">
                <Slider>
                    {data.buero.edges.map(bueroURL => (
                        < div key = {"s-" + bueroURL.originalName} >

                            <BackgroundImage 
                                className="ref_mainImg" 
                                src={bueroURL.node.sizes.src} 
                                placeholder={data.strapiMetadata.placeholder_img.childImageSharp.sizes.src}> 
                            </BackgroundImage> 
                            
                        </div>
                    ))}
                </Slider>
            </div>
        </div>


        <div className="row" style={{ marginTop: '4em' }}>
            
                <div className="col-sm-6 col-md-6 nopadd max-height">
                <Img
                    sizes={data.qualifikationen.sizes}
                    style={{
                        position: "relative",
                        left: 0,
                        bottom: 0,
                        width: "100%",
                        height: "100%"
                    }}
                />
            </div>
                <div className="col-sm-6 col-md-6 nopadd" style={{ backgroundColor: '#7092A9' }}>
                <div className="col-md-12" style={{ backgroundColor: '#D5E1EA' }}>
                        <h2 id="qualifikationen">Qualifikationen unseres Teams</h2>
                </div>
                <div className="col-md-12" style={{ backgroundColor: '#7092A9', color: '#ffffff' }}>
                    <div dangerouslySetInnerHTML={{ __html: data.strapiAbout.Text_Team }} style={{ padding: '3em' }} />
                </div>
            </div>
        </div>


        

        <div className="row" style={{ marginTop: '4em', backgroundColor: '#ffffff' }}>

                <div className="col-xs-12 col-sm-6 col-md-6" style={{ backgroundColor: '#ffffff' }}>

                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12" style={{ backgroundColor: '#D5E1EA' }}>
                        <h2 id="qm">Qualitätsmanagement</h2>
                    </div>
                </div>

                <div className="row" style={{backgroundColor: '#ffffff'}}>
                    <div className="col-sm-6 col-md-12" style={{ padding: '3em 3em 0 3em' }}>
                    
                        <p style={{ color: '#7092A9'}}>Unser Büro ist zertifiziert nach ISO 9001 und geprüft durch den TÜV Süd</p>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12" style={{ padding: '0' }}>
                        <Img
                            sizes={data.tuev.sizes}
                            style={{
                                position: "relative",
                                float: "right",
                                bottom: 0,
                                width: "50%",
                                height: "auto"
                            }}
                        />
                    </div>
                </div>

            </div>

                <div className="col-sm-6 col-md-6 max-height" style={{ paddingLeft: 0, paddingRight: 0, backgroundColor: '#ffffff' }}>
                    <Img
                        sizes={data.imgtuev.sizes}
                        style={{
                            position: "relative",
                            right: 0,
                            bottom: 0,
                            width: "100%",
                            height: "auto",
                            lineHeight: "auto"
                        }}
                    />
            </div>
        </div>


    </div>
</div>

)



export default BueroPage


export const bueroquery = graphql`  
  query BueroQuery { 

    team: imageSharp(id: {regex:"/alle_trans/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },
     buero: allImageSharp(filter: { id: { regex: "/buero[0-9]/" }}) {
         edges {
             node {
                 sizes(maxWidth: 1600) {
                    originalName
                    src
                 }
             }
         }
     },
    qualifikationen: imageSharp(id: {regex:"/img_qualifikationen/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },

    tuev: imageSharp(id: {regex:"/tuev/"}){
        sizes(maxWidth: 800){
        ...GatsbyImageSharpSizes
        }
    },
    imgtuev: imageSharp(id: {regex:"/imgqual/"}){
        sizes(maxWidth: 800){
        ...GatsbyImageSharpSizes
        }
    },
    
    CB: imageSharp(id: {regex:"/CB_1600/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },
   CM: imageSharp(id: {regex:"/CM_1600/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },
   TH: imageSharp(id: {regex:"/TH_1600/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },
   LW: imageSharp(id: {regex:"/LW_1600/"}){
        sizes(maxWidth: 1600){
        ...GatsbyImageSharpSizes
        }
    },

    strapiAbout {
          id
          Text_ProfBoley
          Text_DrMeier
          Text_Team
          Text_Allg
          gf_1_text
          gf_2_text
          gf_3_text
          gf_4_text
          gf_1_name
          gf_2_name
          gf_3_name
          gf_4_name
          buero_slider{
              url
          }
          team_image{
             childImageSharp{
                    sizes {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                    }
                }
          }
    },
    strapiMetadata{
        placeholder_img{
            childImageSharp{
                sizes {
                base64
                tracedSVG
                aspectRatio
                src
                srcSet
                srcWebp
                srcSetWebp
                sizes
                originalImg
                originalName
                }
            }
        }
    },
        ProjectImgs: allFile (filter:{ internal: {description: {regex: "/uploads/"} } } ) {
            edges{
               node{
                childImageSharp{
                    sizes {
                        src
                    }
                }
                
            }
        }
    }
}
`



// WEBPACK FOOTER //
// ./src/pages/buero.js